import { Component, input, model, signal, inject } from '@angular/core';
import { OtapUpgradeTaskDTO, OtapUpgradeTaskInputParametersDTO } from '@app/shared/models/otap-upgrade-task.interface';
import { OtapUpgradeService } from '@services/otap-upgrade/otap.upgrade.service';
import { OtapUpgradeDTO } from '@app/shared/models/otap.upgrade.interface';
import { ToastService } from '@services/toast/toast.service';
import { MatCard, MatCardContent, MatCardHeader, MatCardTitle } from '@angular/material/card';
import { MatButton } from '@angular/material/button';
import { JobTasksTileComponent } from '../job-tasks-tile/job-tasks-tile.component';
import { FormJobTaskComponent } from '../form-job-task/form-job-task.component';

@Component({
  selector: 'app-job-tasks-summary',
  templateUrl: './job-tasks-summary.component.html',
  styleUrls: ['./job-tasks-summary.component.scss'],
  imports: [
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatButton,
    MatCardContent,
    JobTasksTileComponent,
    FormJobTaskComponent
  ]
})
export class JobTasksSummaryComponent {
  readonly task = input.required<OtapUpgradeTaskDTO>();
  readonly job = input.required<OtapUpgradeDTO>();
  readonly index = input.required<number>();
  readonly jobStartEnabled = model.required<boolean>();
  readonly updatedTaskData = signal<OtapUpgradeTaskInputParametersDTO[] | null>(null);
  private readonly otapUpgradeService = inject(OtapUpgradeService);
  private readonly toast = inject(ToastService);

  onTaskDataChanged(updatedData: OtapUpgradeTaskInputParametersDTO[]): void {
    this.updatedTaskData.set(updatedData);
  }

  onSend(task: OtapUpgradeTaskDTO): void {
    const sendData = this.updatedTaskData() ?? task.inputParameters;
    this.otapUpgradeService.startTask(task.jobId, task.id, sendData).subscribe({
      next: (upgradetask) => {
        if (upgradetask !== null) {
          this.jobStartEnabled.set(false);
        }
      },
      error: (error) => {
        this.toast.error({
          message: `${error.error}`,
          dataCy: 'task-cannot-be-started'
        });
      }
    });
  }
}
